import React from "react";

import styles from "./EmptyStateArchived.module.css";

export default function EmptyStateArchived() {
	return (
		<div className={styles.wrapper}>
			<div className={styles.label}>All objectives that are archived will be displayed here</div>
		</div>
	);
}
